module.exports = __webpack_public_path__ + "img/33f7a6263deb7f3eba8680a6234004b3.png";